/**
 * 隐藏页面所有element-ui下拉框
 */

let mouseUp = null
let mouseDown = null

// 隐藏下拉
export const hideDropdown = function(dom) {
  if (!dom) {
    // 默认为头部标题元素
    dom = document.querySelector('#app')
  }
  // 创建鼠标事件
  if (!mouseUp || !mouseDown) {
    console.log('-----create events-----')
    mouseUp = new MouseEvent('mouseup', {
      'view': window,
      'bubbles': true,
      'cancelable': true
    })
    mouseDown = new MouseEvent('mousedown', {
      'view': window,
      'bubbles': true,
      'cancelable': true
    })
  }
  // 顺序触发mouseDown、mouseUp就能触发element隐藏下拉框事件
  dom.dispatchEvent(mouseDown)
  dom.dispatchEvent(mouseUp)
}

// 清除鼠标事件
export const delEvents = function() {
  console.log('-----delete events-----')
  mouseUp = null
  mouseDown = null
}

// dom 滚动时模拟点击空白的效果，实现隐藏下拉框的效果
export const scrollHide = function() {
  document.querySelector('body').onscroll = function() {
    hideDropdown()
  }
  if(document.querySelectorAll('.jssc-qyjz-info-right-basic').length > 0) {
    for (let i= 0;i<document.querySelectorAll('.jssc-qyjz-info-right-basic').length;i++){
      document.querySelectorAll('.jssc-qyjz-info-right-basic')[i].onscroll = function () {
        hideDropdown()
      }
    }
  }
  if(document.querySelector('.el-dialog__body')) {
    document.querySelectorAll('.el-dialog__body').onscroll = function () {
      hideDropdown()
    }
  }
}



// WEBPACK FOOTER //
// ./src/util/hideElement.js